import React from 'react';

import {
  Container,
  Item,
  Infos,
  PaymentInfo,
  CreditCardBrandImage,
  PaymentTitles,
  PaymentTitle,
  SelectIconContainer,
  SelectIcon,
  PromoCard,
} from './styles';

interface ICreditCardItem {
  index?: number;
  action: () => void;
  brand: string;
  lastFourNumbers: string;
  isBrb: boolean;
  voucher: boolean | null;
}

export function CreditCardItem({
  index,
  action,
  brand,
  isBrb,
  lastFourNumbers,
  voucher,
}: ICreditCardItem) {
  return (
    <Container
      style={{
        borderTopWidth: index === 0 ? 0 : 1,
      }}>
      <Item activeOpacity={1} onPress={action}>
        <Infos>
          <CreditCardBrandImage source={{uri: brand}} />
          <PaymentInfo>
            <PaymentTitles>
              <PaymentTitle>
                •••• {lastFourNumbers} ({voucher ? 'Vale' : 'Crédito'})
              </PaymentTitle>
            </PaymentTitles>
           {isBrb && <PromoCard>Cartão BRB</PromoCard>}
          </PaymentInfo>
        </Infos>
        <SelectIconContainer>
          <SelectIcon name="chevron-right" />
        </SelectIconContainer>
      </Item>
    </Container>
  );
}
